import { useMutation, UseMutationOptions } from '@tanstack/react-query';

import { gqlClient } from '@/api/graphql-client';
import { graphql } from '@/gql';
import {
  AddTagsToEntityMutation,
  AddTagsToEntityMutationVariables,
} from '@/gql/graphql';

const AddTagsToEntity = graphql(`
  mutation AddTagsToEntity($input: AddTagsToEntityInput!) {
    addTagsToEntity(input: $input) {
      ... on Project {
        id
        tags {
          id
          colour
          name
        }
      }
      ... on ScheduledEvent {
        id
        tags {
          id
          colour
          name
        }
      }
      ... on Customer {
        id
        tags {
          id
          colour
          name
        }
      }
      ... on Material {
        id
        tags {
          id
          colour
          name
        }
      }
      ... on Supplier {
        id
        tags {
          id
          colour
          name
        }
      }
    }
  }
`);

const useAddTagsToEntity = (
  options?: UseMutationOptions<
    AddTagsToEntityMutation,
    unknown,
    AddTagsToEntityMutationVariables['input']
  >
) => {
  return useMutation({
    mutationFn: (input) => {
      return gqlClient.request(AddTagsToEntity, {
        input,
      });
    },
    ...options,
  });
};

export default useAddTagsToEntity;
